import { PRAYER_TYPE } from '@/src/features/pray/models/prayerIntentionType.enum'

import { MESSAGE_TYPE } from './Message.enums'

export const messageTypePrayerTypeMap = {
  [MESSAGE_TYPE.THANKS_INTENTION_PRAYER]: PRAYER_TYPE.INTENTION,
  [MESSAGE_TYPE.THANKS_ARRIVAL_INTENTION_PRAYER]: PRAYER_TYPE.ARRIVAL,
  [MESSAGE_TYPE.THANKS_BIRTHDAY_INTENTION_PRAYER]: PRAYER_TYPE.BIRTHDAY,
}
